// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"8acd85a4","209":"a4d1a30d","717":"71725952","787":"d3befce1","829":"2e4edc7f"}[chunkId] + ".chunk.js";
};